import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Paper from 'material-ui/Paper'
import Tabs, {Tab} from 'material-ui/Tabs'

import styles from '../styles'
import Container from '../../../common/components/Container'
import WithMe from '../containers/withMe'
import WithOthers from '../containers/withOthers'

import {shared as text} from '../text'

class Shared extends React.Component {

  getTabValue = tab => {
    switch (tab) {
      case 'withMe':
        return 0
      case 'withOthers':
        return 1
      default:
        return 0
    }
  }

  handleChange = (e, v) => {
    switch (v) {
      case 0:
        this.props.history.push('/compartido?con=migo')
        break
      case 1:
        this.props.history.push('/compartido?con=otros')
        break
      default:
        this.props.history.push('/compartido?con=migo')
    }
  }

  render() {
    const {tab, history} = this.props
    return (
      <Container>
        <Paper>
          <Tabs
            value={this.getTabValue(tab)}
            onChange={this.handleChange}
            centered={true}
            fullWidth={false}
            scrollButtons="auto"
            indicatorColor="primary"
          >
            <Tab label={text.tabWithMe}/>
            <Tab label={text.tabWithOthers}/>
          </Tabs>
        </Paper>
        {tab === 'withMe' ? <WithMe history={history}/> : null}
        {tab === 'withOthers' ? <WithOthers/> : null}
      </Container>
    )
  }
}

Shared.propTypes = {
  tab: PropTypes.oneOf(['withMe', 'withOthers']),
  history: PropTypes.object,
}

export default withStyles(styles)(Shared)



// WEBPACK FOOTER //
// ./src/sections/shared/components/shared.js